import { devtools } from 'zustand/middleware';

/** @see https://github.com/pmndrs/zustand/discussions/842 */
export const devtoolsInNonProd = (process.env.NODE_ENV === 'production'
	? (fn: any) => fn
	: devtools) as unknown as typeof devtools;
